module.exports = fox._r("images/preloader-conic.png", __webpack_public_path__ + "images/preloader-conic.png");


//////////////////
// WEBPACK FOOTER
// ./images/preloader-conic.png
// module id = 23
// module chunks = 5